import { render } from "./edit.vue?vue&type=template&id=3132f97a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "@/assets/custom-outside.css?vue&type=style&index=0&id=3132f97a&scoped=true&lang=css"

import exportComponent from "/Users/charcoaldev/Documents/GitHub/beardrug-pos/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3132f97a"]])

export default __exports__